module.exports = __webpack_public_path__ + "static/media/pstep2img4.87a11eb8.PNG";